import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

const Address = ({ address }) => {
  if (isEmpty(address)) return null;
  return (
    <span>
      {address.street} {address.street2}, {address.city}, {address.state}, {address.zip}
    </span>
  );
};
Address.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    street2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
};

export default Address;
